import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export const TaskStoreModel = {
  startAt: new Date(),
  endAt: new Date(),
  title: '',
  description: '',
  notes: '',
  phone: '',
  address: '',
  finished: false,
  clientId: null,
  userId: null,
  sendNotification: true,
};

export default {
  namespaced: true,
  state: {
    activeDay: new Date(),
    task: { ...TaskStoreModel },
    tasks: [],
  },
  mutations: {
    updateActiveDay(state, activeDay) {
      state.activeDay = activeDay;
    },
    updateTask(state, task) {
      state.task = task;
    },
    updateTasks(state, tasks) {
      state.tasks = tasks;
    },
    addTask(state, task) {
      state.tasks.push(task);
    },
    putTask(state, task) {
      state.tasks = state.tasks.map((value) => (task.id === value.id ? task : value));
    },
    deleteAction(state, id) {
      state.tasks = state.tasks.filter((item) => item.id !== id);
    },
    resetTask(state) {
      state.task = { ...TaskStoreModel };
    },
  },
  actions: {
    async getTask({ commit }, id) {
      axiosInstance
        .get(urlsAPI.tasksURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            // convert to date for datetime picker
            response.data.startAt = new Date(response.data.startAt);
            response.data.endAt = new Date(response.data.endAt);
            commit('updateTask', response.data);
          }
        })
        .catch(handlerError);
    },

    async getTasks({ commit }, params) {
      return axiosInstance
        .get(urlsAPI.tasksURL, {
          params,
        })
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateTasks', response.data);
          }
        })
        .catch(handlerError);
    },

    async createTask({ commit }, body) {
      return axiosInstance
        .post(urlsAPI.tasksURL, body)
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          commit('addTask', response.data);
          return response.data;
        })
        .catch(handlerError);
    },

    async updateTask({ commit }, { id, body }) {
      axiosInstance
        .put(urlsAPI.tasksURL + id, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('putTask', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, id) {
      axiosInstance
        .delete(urlsAPI.tasksURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', id);
          }
        })
        .catch(handlerError);
    },

    searchTask({ commit }, keyword) {
      axiosInstance
        .get(urlsAPI.tasksSearchURL, {
          params: {
            keyword,
          },
        })
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateTasks', response.data);
          }
        })
        .catch(handlerError);
    },

    async getLatestTaskOfCustomer(_, id) {
      return axiosInstance
        .get(urlsAPI.tasksLatestURL(id))
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            return response.data;
          }
        })
        .catch(handlerError);
    },
  },
};
